var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Sorry, the page you're looking for can't be found.")]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to Home")]),_vm._v(" "),_c('router-link',{attrs:{"to":""}},[_vm._v("Go Back")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"/images/common/404.png"}})])
}]

export { render, staticRenderFns }